// extracted by mini-css-extract-plugin
export var button = "_kh-2";
export var card = "_kh-0";
export var closeButtonContainer = "_kh-3";
export var iconContainer = "_kh-1";